import { Component } from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface TokenAuthListPageProps extends NSARouterMakerResult, CredentialProps { }

export default class TokenAuthListPage extends Component<TokenAuthListPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section lists all the Token Auth credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
                }}
                pages={{
                    entity: CredentialEntities.token_auth(this.props),
                    list: {}
                }}
            >
                <></>
            </CredentialLayout >
        );
    }
}